import styled from 'styled-components';
import { color } from 'theme';

export const StyledWrapper = styled.div`
  position: relative;
  background-color: ${color('midnight_100')};
`;
